import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
    SimpleItem,
    GroupItem,
    Label,
    EmptyItem,
} from "devextreme-react/form";
import { Button } from "devextreme-react";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import { inserirOuAtualizar, criarSituacaoDividaDs } from "../../DataSources";
import { LoadIndicator } from "devextreme-react/load-indicator";
import ShowError from "../../AppServices";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
    id: undefined,
    sequencial: undefined,
    nome: "",
    situacaoDeCredito: 1,
    situacaoInterna: 0,
    tipoCobranca: 0,
    tipoCancelamento: 0,
    listarParaAcordos: 0,
    listarParaAcompanhamento: 0,
    enviarParaLivro: 0,
    listarParaArrecadacao: 0,

    _uiTextoBotao: "Salvar",
    _uiCarregando: false,
};

export default class SituacaoDiatFormNovo extends React.Component {
    constructor(props) {
        super(props);

        template.prefeituraId = UserInfo.getPrefeitura();
        this.state = { ...template, _uiCarregando: true };
        this.dataSource = criarSituacaoDividaDs();

        this.situacaoCreditoOptions = {
            editorType: "dxSelectBox",
            dataSource: [
                { id: 1, descricao: "EXIGIVEL" },
                { id: 2, descricao: "SUSPENSO" },
                { id: 3, descricao: "EXTINTO" },
            ],
            valueExpr: "id",
            displayExpr: "descricao"
        };

        this.situacaoInternaOptions = {
            editorType: "dxSelectBox",
            dataSource: [
                { id: 0, descricao: "NENHUM" },
                { id: 1, descricao: "CDA CANCELADA" },
                { id: 2, descricao: "CDA GERADA" },
                { id: 3, descricao: "SEPARADA PARA CANCELAMENTO" },
                { id: 4, descricao: "SEPARADA PARA COBRANÇA" },
                { id: 5, descricao: "ENVIADA PARA COBRANÇA" },
                { id: 6, descricao: "PROBLEMA NA COBRANÇA" },
                { id: 7, descricao: "EM COBRANÇA" },
            ],
            valueExpr: "id",
            displayExpr: "descricao"
        };

        this.tipoCobrancaOptions = {
            editorType: "dxSelectBox",
            dataSource: [
                { id: 0, descricao: "NENHUM" },
                { id: 1, descricao: "PROTESTO" },
                { id: 2, descricao: "EXECUCAO FISCAL" },
            ],
            valueExpr: "id",
            displayExpr: "descricao"
        };

        this.tipoCancelamentoOptions = {
            editorType: "dxSelectBox",
            dataSource: [
                { id: 0, descricao: "NENHUM" },
                { id: 1, descricao: "CANCELAMENTO" },
                { id: 2, descricao: "PRESCRICAO" },
                { id: 3, descricao: "REMISSAO" },
                { id: 4, descricao: "EXCLUSAO" },
                { id: 5, descricao: "ISENCAO" },
            ],
            valueExpr: "id",
            displayExpr: "descricao"
        };

        this.simNaoOptions = {
            editorType: "dxSelectBox",
            dataSource: [
                { id: 0, descricao: " " },
                { id: 1, descricao: "SIM" },
                { id: 2, descricao: "NAO" },
            ],
            valueExpr: "id",
            displayExpr: "descricao"
        };



        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    componentDidMount() {
        if (this.props.match.params.id !== undefined) {
            this.setState({ _uiCarregando: true });

            this.dataSource
                .byKey(this.props.match.params.id)
                .then((data) => {
                    if (data === undefined) {
                        notify("Registro não encontrado.", "error");
                        this.props.history.push("/situacoesdiat");
                    }
                    this.setState({
                        ...data,
                        _uiCarregando: false,
                    });
                })
                .catch((error) => {
                    ShowError(error.response.data);
                    notify(error, "error", 2000);
                    this.props.history.goBack();
                });
        } else {
            this.setState({ ...template, _uiCarregando: false });
        }
    }

    render() {
        if (this.state._uiCarregando) {
            return (
                <div className={"content-block dx-card responsive-paddings"}>
                    <div
                        style={{
                            display: "flex",
                            marginTop: "25px",
                            justifyContent: "center",
                            alignContent: "center",
                            justifyItems: "center",
                            alignItems: "center",
                        }}
                    >
                        <LoadIndicator width={60} height={60} />
                    </div>
                </div>
            );
        }

        return (
            <React.Fragment>
                <div className={"content-block dx-card responsive-paddings"}>
                    <form>
                        <Form formData={this.state} >
                            <GroupItem caption="SITUAÇÃO DA DÍVIDA ATIVA" colCount={2}>
                                <SimpleItem dataField={"sequencial"}
                                    colSpan={2}
                                    editorOptions={{ readOnly: true }}
                                >
                                    <Label text="Sequencial" />
                                </SimpleItem>
                                <SimpleItem dataField={"nome"} colSpan={2}>
                                    <Label text="Nome" />
                                </SimpleItem>
                                <SimpleItem dataField={"situacaoDeCredito"} colSpan={1} editorType={"dxSelectBox"} editorOptions={this.situacaoCreditoOptions}>
                                    <Label text="Situação do Crédito" />
                                </SimpleItem>
                                <SimpleItem dataField={"situacaoInterna"} colSpan={1} editorType={"dxSelectBox"} editorOptions={this.situacaoInternaOptions}>
                                    <Label text="Situação Interna" />
                                </SimpleItem>
                                <SimpleItem dataField={"tipoCobranca"} colSpan={1} editorType={"dxSelectBox"} editorOptions={this.tipoCobrancaOptions}>
                                    <Label text="Tipo Cobrança" />
                                </SimpleItem>
                                <SimpleItem dataField={"tipoCancelamento"} colSpan={1} editorType={"dxSelectBox"} editorOptions={this.tipoCancelamentoOptions}>
                                    <Label text="Tipo Cancelamento" />
                                </SimpleItem>
                                <SimpleItem dataField={"listarParaAcordos"} colSpan={1} editorType={"dxSelectBox"} editorOptions={this.simNaoOptions}>
                                    <Label text="Listar em Acordos" />
                                </SimpleItem>
                                <SimpleItem dataField={"listarParaAcompanhamento"} colSpan={1} editorType={"dxSelectBox"} editorOptions={this.simNaoOptions}>
                                    <Label text="Listar em Acompanhamento" />
                                </SimpleItem>
                                <SimpleItem dataField={"enviarParaLivro"} colSpan={1} editorType={"dxSelectBox"} editorOptions={this.simNaoOptions}>
                                    <Label text="Enviar para Livro" />
                                </SimpleItem>
                                <SimpleItem dataField={"listarParaArrecadacao"} colSpan={1} editorType={"dxSelectBox"} editorOptions={this.simNaoOptions}>
                                    <Label text="Listar para Arrecadação" />
                                </SimpleItem>
                                <SimpleItem dataField={"chaveMigracao"} colSpan={2} editorOptions={{readOnly: true}}>
                                    <Label text="Chave Migração" />
                                </SimpleItem>
                            </GroupItem>
                        </Form>

                        <div
                            style={{
                                marginTop: "10px",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <div style={{ display: "inline-block" }}>
                                <Button
                                    width={120}
                                    text="Salvar"
                                    type="success"
                                    onClick={this.ok}
                                    disabled={this.state.loadIndicatorVisivel}
                                >
                                    <LoadIndicator
                                        className="button-indicator"
                                        id="small-indicator"
                                        height={20}
                                        width={20}
                                        visible={this.state.loadIndicatorVisivel}
                                        style={{ marginRight: "10px", verticalAlign: "middle" }}
                                    />
                                    <span className="dx-button-text">
                                        {this.state._uiTextoBotao}
                                    </span>
                                </Button>
                            </div>
                            <div style={{ display: "inline-block", marginLeft: "10px" }}>
                                <Button
                                    disabled={this.state.loadIndicatorVisivel}
                                    text="Cancelar"
                                    width={120}
                                    onClick={this.cancel}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </React.Fragment>
        );
    }

    ok() {
        this.setState(
            {
                loadIndicatorVisivel: true,
                _uiTextoBotao: "Salvando...",
            },
            async () => {
                const entidade = {
                    ...this.state,
                    cpfCnpj:
                        this.state.tipoPessoa === 1
                            ? this.state._uiCpf
                            : this.state._uiCnpj,
                };

                await inserirOuAtualizar(this.dataSource, entidade)
                    .then(() => {
                        notify("Operação realizada com sucesso", "success");
                        this.props.history.goBack();
                    })
                    .catch((error) => {
                        console.log("error response", error);
                        ShowError(error.response.data);
                        notify(error, "error", 2000);
                        this.setState({ loadIndicatorVisivel: false, textoBotao: "Salvar" });
                    });
            }
        );
        // console.log("cadastro contribuinte", this.state);
        // await this.setState({
        //   loadIndicatorVisivel: true,
        // });
        // const entidade = {
        //   ...this.state,
        //   cpfCnpj:
        //     this.state.tipoPessoa == 1 ? this.state._uiCpf : this.state._uiCnpj,
        // };

        // inserirOuAtualizar(this.contribuinteDs, entidade)
        //   .then(
        //     function () {
        //       notify("Contribuinte cadastrado com sucesso.", "success");
        //       _cadastroCorrente = undefined;
        //       _cancelando = true;
        //       Memoria.removerEdicao(this.props.location);
        //       this.props.history.goBack();
        //     }.bind(this)
        //   )
        //   .catch(function (error) {
        //     console.log(error);
        //     this.setState({ loadIndicatorVisivel: false });
        //     notify(error, "error", 1500);
        //   });
    }

    cancel() {
        notify("Operação cancelada", "warning");
        this.props.history.goBack();
    }
}
